import { T, UnstyledButton } from "@classdojo/web";
import { BodyText, theme } from "@classdojo/web/nessie";
import { IdeasPlayIcon, IdeasPauseIcon } from "components/IdeasIcons";
import RoundedIconButton from "components/RoundedIconButton";

type CountdownControlsProps = {
  seconds: number;
  icon: string;
  toggle: VoidFunction;
  restart: VoidFunction;
  incrementTimer: VoidFunction;
};

export default function CountdownControls({ seconds, icon, toggle, restart, incrementTimer }: CountdownControlsProps) {
  return (
    <div
      sx={{
        display: "flex",
        marginBottom: "dt_l",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <div onClick={restart} sx={{ width: 24, height: 24, position: "relative" }}>
        {seconds > 0 && <img src="/static/images/redo.png" width={24} height={24} />}
      </div>
      <div sx={{ marginLeft: "dt_l", marginRight: "dt_l", position: "relative" }}>
        <RoundedIconButton
          backgroundColor={theme.colors.dt_content_accent}
          onClick={toggle}
          data-name="countdown_controls:play_paus_button"
        >
          {icon === "play" ? (
            <IdeasPlayIcon size="l" color="dt_content_light" />
          ) : (
            <IdeasPauseIcon size="l" color="dt_content_light" />
          )}
        </RoundedIconButton>
      </div>
      <UnstyledButton data-name="countdown_controls:countdown_controls_plus_10" onClick={incrementTimer}>
        <BodyText level={2}>
          <T str="dojo.toolkit:countdown_controls.plus_10" fallback="+10" />
        </BodyText>
      </UnstyledButton>
    </div>
  );
}
